module.exports = __webpack_public_path__ + "media/images/blick-ins-buch-label-19c18a08758ae2448ff63358d83a9134.svg";